import React, { PureComponent } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';

// import styles from './styles';
class RsaRedirect extends PureComponent {

  componentDidMount(){
    
    const currentUrl = window.location.href;
    console.log(this.props);

  

    const jwt = this.getQueryVariable("jwt");
    const redirectUrl = this.getQueryVariable("url");
    this.props.setjwt(jwt);


    this.props.pushPage({ pathname: redirectUrl });
    this.props.replacePage({ pathname: redirectUrl });



    // call('ui.history.push', { pathname: path });
    // set('rsa.rsaVisible', false); 
    // call('ui.history.replace', { pathname: path });


  } 

  getQueryVariable(variable)
  {
         var query = window.location.search.substring(1);
         var vars = query.split("&");
         for (var i=0;i<vars.length;i++) {
                 var pair = vars[i].split("=");
                 if(pair[0] == variable){return pair[1];}
         }
         return(false);
  }

  
  render(){

    return(
      <div></div>
    );
  }

}

export default createContainer({
  $queries: {
    rsa:{
      rsaAuthorised:true
    },
    ui:{
      goBack: { $call: 'goBack' },
    },
    pushPage : { $call: 'ui.history.replace' },
    replacePage: { $call: 'ui.history.replace' },
    setjwt: { $call: 'rsa.setjwt' },
    i18n: {
      messages: true,
    }
  },
})(RsaRedirect);
